import PropTypes from 'prop-types'
import actions from 'redux-auto'
import React from 'react'
import i18n from 'i18next'
import Api from '#services/api'
import UserSearchModal from '#components/o/Chat/UserSearchModal'

export function AddAusbilderModal(props) {
  const checkResultForWarning = result => {
    const hasAlreadyAusbilder = props.ausbilderListe.filter(a => a.id === result.id).length > 0
    if (hasAlreadyAusbilder) {
      return {
        message: i18n.t('add_ausbilder_already_exists'),
        confirmDisabledReason: i18n.t('add_ausbilder_add_button_disabled_reason_already_added'),
      }
    }

    return null
  }

  const searchAusbilder = async ausbilderId => {
    try {
      const apiResult = await Api.getAusbilder(ausbilderId)
      return {
        user: {
          id: apiResult.id,
          info: `${apiResult.firstname} ${apiResult.lastname} | ${apiResult.markt}`,
          warning: checkResultForWarning(apiResult),
        },
      }
    } catch (e) {
      if (e.message === 'api_get_Ausbilder_not_found') {
        return {
          error: {
            message: i18n.t('add_ausbilder_no_found', [ausbilderId]),
            confirmDisabledReason: i18n.t('add_ausbilder_add_button_disabled_reason_not_found'),
          },
        }
      }

      throw e
    }
  }

  const addAusbilder = async ausbilderId => {
    await Api.setUserAusbilder(ausbilderId)
    actions.meineAusbilder.getUserAusbilder()
  }

  const triggerConfig = {
    testId: 'addAusbilder',
    text: i18n.t('meine_ausbilder_add_ausbilder'),
    disabled: props.ausbilderListeIsLoading,
    disabledReason: i18n.t('meine_ausbilder_add_ausbilder_disabled_reason'),
  }
  const modalConfig = {
    testId: 'addAusbilderModal',
    headlineText: i18n.t('meine_ausbilder_add_ausbilder'),
    tooltipText: i18n.t('add_ausbilder_tooltip'),
    searchFieldPlaceholder: i18n.t('add_ausbilder_search_by_id'),
    searchResultTitle: i18n.t('add_ausbilder_found'),
    confirmDisabledReasons: {
      userIdNotValid: i18n.t('add_ausbilder_search_button_disabled_reason'),
      searchInProgress: i18n.t('add_ausbilder_isSearching_disable_reason'),
      confirmInProgress: i18n.t('add_ausbilder_add_button_disabled_reason_adding'),
    },
    searchCallback: searchAusbilder,
    confirmCallback: addAusbilder,
  }

  return <UserSearchModal triggerConfig={triggerConfig} modalConfig={modalConfig} />
}

AddAusbilderModal.propTypes = {
  ausbilderListe: PropTypes.arrayOf(
    PropTypes.shape({
      firstname: PropTypes.string,
      id: PropTypes.number,
      lastname: PropTypes.string,
      markt: PropTypes.string,
    }),
  ),
  ausbilderListeIsLoading: PropTypes.bool,
}
